<template lang="html">
  <div v-if="isEnd" class="end-line">
    <div class="end-line-text">{{text}}</div>
  </div>
</template>

<script>
export default {
  name: 'ListEndLine',
  props: {
      text: {
          type: String,
          default: '到底了哦~'
      },
      isEnd: {
          type: Boolean,
          default: false
      },
  },
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../style/main";

.end-line {
  width: 100%;
  text-align: center;
  &-text{
    font-size: use(24);
    line-height: use(30);
    display: inline-block;
    margin: use(30) auto use(40);
    color: #999999;
    text-align: center;
    position: relative;
  }
  &-text:before{
    content:'';
    position: absolute;
    width: use(193);
    left: use(-227);
    top:50%;
    height: use(2);
    background-color: #D8D8D8;
    transform: translateY(-50%);
  }
  &-text:after{
    content:'';
    position: absolute;
    width: use(193);
    right: use(-227);
    top:50%;
    height: use(2);
    background-color: #D8D8D8;
    transform: translateY(-50%);
  }
}
</style>
